/** @jsxImportSource @emotion/react */
/* eslint-disable react-refresh/only-export-components */
import { css } from '@emotion/react';
import React from 'react';
import get from 'lodash/get';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { getInputStyle, helperTextPlaceHolderStyle, menuListStyle } from '../../styles/sharedDropdownStyles';
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { useField } from 'formik';

interface IProps {
  autoFocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  fullWidth?: boolean;
  items: Array<any>;
  helperText?: string;
  hideIcon?: boolean;
  label?: string;
  name: string; 
  valueField: string;
  primaryField: string;
  secondaryField?: string;
  onChange?: (event: React.ChangeEvent<{ value: unknown }>, child?: React.ReactNode) => void; 
}

export const iconStyle = (color: string) => { 
  return css`  
  path {
    fill: ${color};
  }
`}

export const StyledSelect = (props: IProps) => {
  const {
    autoFocus,
    disabled,  
    fullWidth,
    items,
    label,
    name,
    primaryField,
    secondaryField,    
    valueField,
    onChange   
  } = props;
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const [field, meta] = useField(name);     

  const handleChange = (event, child?: React.ReactNode) => {
/*     const eventTarget = event.target as HTMLInputElement;
    const { id, value: newValue } = eventTarget; */
    field.onChange(event);
    // setOpen(false);
    if (onChange) {
      onChange(event, child);
    }
  };

  const forceUpdateOnItemListChange = `${name}-${items.length}`;

  return (
    <FormControl 
      sx={{ p: 0, minWidth: mikeSharedTheme.spacing(15) }}
      disabled={disabled}
      error={meta.error ? true : false}
      fullWidth={fullWidth}
      size="small"
      variant={'filled'}    
    >
      {label && (
        <InputLabel id="styled-select-label" htmlFor={name} required={false} disabled={disabled}>
          {label}
        </InputLabel>
      )}
      <Select        
        native={false}
        labelId="styled-select-label"
        autoFocus={autoFocus}
        key={forceUpdateOnItemListChange}       
        sx={getInputStyle(!label)}
        name={field.name}
        inputProps={{         
          name,
          id: name
        }}
        open={open}
        onChange={handleChange}
        onClose={handleClose}
        onOpen={handleOpen}
        MenuProps={{ sx: { paper: menuListStyle } }}
       value={field.value !== undefined ? field.value : ""}     
      >
        {items && items.map((item) => {
          const itemValue = get(item, valueField);
          const selectedItemValue = field.value !== undefined ? field.value : "";
          const primary = get(item, primaryField);
          const secondary = secondaryField && get(item, secondaryField);
          return (
            <MenuItem  key={itemValue} value={itemValue}>            
              <ListItemText
                sx={{
            "& .MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#000000", //Adjust text color here
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000", //Adjust text color here
            },
            "& .MuiInputBase-root.Mui-disabled": {
              backgroundColor: "#f9f9f9", //Adjust background color here
            },
            "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
              {
                borderColor: "#000000", //Adjust border color here
              },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "rgba(0, 0, 0, 0.87)", // Darker label color
            },
          }}
                primary={primary}
                secondary={itemValue === selectedItemValue && !open ? null : secondary}
              />
            </MenuItem>
          );
        })}
      </Select>
      {meta.error ? (
        <FormHelperText>{meta.error}</FormHelperText>
      ) : (
        <div css={helperTextPlaceHolderStyle} />
      )}
    </FormControl>
  );
};
